var _defs, _rect, _path, _path2, _path3, _line, _line2, _path4, _polyline, _text, _path5, _path6, _circle, _path7, _path8, _polygon, _line3, _polygon2, _rect2, _rect3, _rect4, _rect5, _polyline2, _circle2, _rect6, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _rect7, _polygon3, _polygon4, _polygon5, _path9, _line10, _line11, _ellipse, _line12, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandpostioningtab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8c4df;}.cls-2{fill:#fff;}.cls-10,.cls-11,.cls-12,.cls-15,.cls-3,.cls-7,.cls-8{fill:none;stroke-miterlimit:10;}.cls-11,.cls-3{stroke:#e5ac24;}.cls-3{stroke-width:1.21px;}.cls-4{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-4,.cls-5{fill:#2f2143;}.cls-6{fill:#fdc435;}.cls-7{stroke:#2f2143;stroke-width:2.38px;}.cls-12,.cls-8{stroke:#3a4c69;}.cls-8{stroke-width:1.37px;}.cls-9{fill:#e5ac24;}.cls-10,.cls-15{stroke:#fff;}.cls-10{stroke-width:1.16px;}.cls-11{stroke-width:1.08px;}.cls-12{stroke-width:0.4px;}.cls-13{fill:#fdfefe;}.cls-14{fill:#cd922a;}.cls-15{stroke-width:0.8px;}.cls-16{fill:#e0e0e0;}.cls-17{fill:#f7a7a8;}.cls-18{fill:#263238;}.cls-19{fill:#fec536;}.cls-20,.cls-23,.cls-24,.cls-30{fill:#2e1f42;}.cls-21{fill:#ebebeb;}.cls-22{fill:#ab6cad;}.cls-23{opacity:0.4;}.cls-24,.cls-25{opacity:0.3;}.cls-26{fill:#f1f0f0;}.cls-27{fill:#f3908f;}.cls-28{fill:#fafbfb;}.cls-29{fill:#b16669;}.cls-30{opacity:0.15;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "brand postioning tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 765,
    height: 277
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.5,218.5a3.91,3.91,0,1,1,1.22,5.39,3.92,3.92,0,0,1-1.22-5.39",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.12,198.46a3.91,3.91,0,1,1,1.21,5.39,3.91,3.91,0,0,1-1.21-5.39",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.8,217.52A3.91,3.91,0,1,1,31,223a3.9,3.9,0,0,1,.78-5.48",
    transform: "translate(0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 48.9,
    y1: 220.56,
    x2: 38.02,
    y2: 220.55
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 53.74,
    y1: 216.79,
    x2: 50.55,
    y2: 203.88
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.1,39h0a12.5,12.5,0,0,0-.13-4h0l1.79-2.46L59.5,29.83l-3-.28,0,0a12.48,12.48,0,0,0-2.9-2.71h0l-.47-3-2.83-1.06-2.34,1.94v0a12.81,12.81,0,0,0-4,.13h0L41.5,23.08l-2.75,1.24-.28,3h0a12.69,12.69,0,0,0-2.71,2.9h0l-3,.48L31.7,33.56l1.94,2.34h0a12.79,12.79,0,0,0,.14,4h0L32,42.33l1.25,2.74,3,.29v0A12.48,12.48,0,0,0,39.19,48h0l.48,3,2.82,1.06,2.34-1.94v0a12.79,12.79,0,0,0,4-.13h0l2.47,1.79L54,50.58l.29-3h0a12.65,12.65,0,0,0,2.7-2.9h0l3-.48L61,41.34ZM56,41.1a10.29,10.29,0,1,1-6-13.28A10.31,10.31,0,0,1,56,41.1",
    transform: "translate(0)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "280.41 243.98 292.48 252.42 297.83 238.7 309.9 247.14 315.25 233.41 327.33 241.85"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(248.14 181.02)"
  }, "BRAND POSITIONING")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M358,97.85a37.64,37.64,0,1,1-37.64-37.64A37.64,37.64,0,0,1,358,97.85",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M354.82,97.85a34.48,34.48,0,1,1-34.48-34.48,34.48,34.48,0,0,1,34.48,34.48",
    transform: "translate(0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 320.34,
    cy: 97.85,
    r: 23.18
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M331.57,97.85a11.23,11.23,0,1,1-11.23-11.23,11.23,11.23,0,0,1,11.23,11.23",
    transform: "translate(0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.59,97.93a8.25,8.25,0,1,1-8.25-8.25,8.24,8.24,0,0,1,8.25,8.25",
    transform: "translate(0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "327.33 95.52 328.69 99.74 324.36 98.82 320.02 97.89 323 94.6 325.96 91.31 327.33 95.52"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 327.33,
    y1: 95.52,
    x2: 380.35,
    y2: 78.35
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "390.23 78.15 381.39 81.02 379.07 78.77 379.63 75.58 388.47 72.72 388.18 75.82 390.23 78.15"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 464.62,
    y: 242.73,
    width: 8.78,
    height: 10.22
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 479.09,
    y: 236.41,
    width: 8.78,
    height: 16.53
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 494.64,
    y: 227.79,
    width: 8.78,
    height: 25.15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 510.72,
    y: 219.56,
    width: 8.78,
    height: 33.38
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "464.62 238.58 473.4 238.58 479.09 232.32 487.87 232.32 492.65 225.57 503.42 225.57 510.06 216.95 519.51 216.95"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 666.24,
    cy: 44.31,
    r: 7.93,
    transform: "translate(515.79 694.85) rotate(-80.78)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 674.18,
    y: 94.51,
    width: 38.35,
    height: 55.29
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 679.43,
    y1: 109.15,
    x2: 699.22,
    y2: 109.15
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 679.43,
    y1: 114.22,
    x2: 699.22,
    y2: 114.22
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 679.43,
    y1: 119.29,
    x2: 699.22,
    y2: 119.29
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 679.43,
    y1: 124.36,
    x2: 699.22,
    y2: 124.36
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 679.43,
    y1: 129.43,
    x2: 699.22,
    y2: 129.43
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 679.43,
    y1: 134.5,
    x2: 699.22,
    y2: 134.5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 679.43,
    y1: 139.57,
    x2: 699.22,
    y2: 139.57
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 679.43,
    y1: 144.65,
    x2: 699.22,
    y2: 144.65
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 701.12,
    y: 97.42,
    width: 8.77,
    height: 9.3
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "507.1 48.3 557.81 68.4 532.9 83.95 507.1 48.3"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "507.1 48.3 545.18 76.41 545.18 86.45 550.11 74.49 507.1 48.3"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "539.51 78.62 545.18 86.45 545.18 76.41 539.51 78.62"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M720.09,223.11H682.15a3.67,3.67,0,0,0-3.67,3.68v17.79a3.67,3.67,0,0,0,3.67,3.68h3.11c.23,1.19.37,4.41-3.88,6.65,0,0,11.16-.53,11.32-6.65h27.39a3.67,3.67,0,0,0,3.67-3.68V226.79a3.67,3.67,0,0,0-3.67-3.68",
    transform: "translate(0)"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 685.32,
    y1: 229.72,
    x2: 716.9,
    y2: 229.72
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 685.32,
    y1: 235.51,
    x2: 716.9,
    y2: 235.51
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow",
    className: "cls-16",
    cx: 119.28,
    cy: 212.52,
    rx: 50.32,
    ry: 29.05
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 685.32,
    y1: 241.84,
    x2: 716.9,
    y2: 241.84
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M162.16,215.71l7.29-14.36,14.67,8.58L166,231.29s-9-.83-10.41-5.51S159.69,217.26,162.16,215.71Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M151.82,221.35a7.55,7.55,0,0,0-2,2.22c-.59.88-.41,5.13-1,7.1s-1,2.5-1.94,5c-1,2.74-3,5.25-.8,12.29s5.68,10.4,8.63,12.12a7.81,7.81,0,0,0,3.56.86s3.87-1.46,3.28-3.75S151.82,221.35,151.82,221.35Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M168.79,229.08a8.35,8.35,0,0,1-1.53,2.43,19.4,19.4,0,0,0-2.51,7c-2.28,11.15,2.15,16.82-3.84,21-1.74,1.09-5.35.79-10.83-6.23-2.8-3.59-4.39-11-3.3-14.31s2.58-5.52,3.29-8.09.34-7.36,1.75-9.57a10.47,10.47,0,0,1,3.48-3c1.07-.64,3.4-1.49,4.48-2.11s1.68-1.32,2.38-.53l-1.25,1.55c-2,2.7-1.41,3.1-1.37,4.54a22.71,22.71,0,0,1-.72,4.59c1.39-1.75,2-3.29,3.48-3s1.7.2,3.87,2.24S168.89,228.44,168.79,229.08Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M150.08,253.32c-2.8-3.59-4.39-11-3.3-14.31a30,30,0,0,1,1.28-3.24c0,.22-.11.45-.14.65-.07.43-.13.86-.17,1.3a10,10,0,0,0,.56,5.06c.63,1.39,2.08,4.87,4,4.95,1.06,0,2-1,2.37-2.18.17-.51.45-1.86.45-1.86a16.65,16.65,0,0,1,4.88,2c2.72,1.8,2.62,2.2,2.62,2.2a7.25,7.25,0,0,0-.09,2.39,6,6,0,0,0,1,2.38,3.93,3.93,0,0,0,.7.55,7.3,7.3,0,0,1-3.3,6.35C159.17,260.64,155.56,260.34,150.08,253.32Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M164.75,238.55a38.16,38.16,0,0,0-.69,8.91c-1,2.86-1.92,2.77-2.05,1.29s1.85-7.61,3.32-12.68C165.1,236.91,164.92,237.75,164.75,238.55Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M158,220.68a6.24,6.24,0,0,1,1.09-4.08c.27-.12.52-.25.72-.36,1.17-.67,1.68-1.32,2.38-.53l-1.25,1.55c-2,2.7-1.41,3.1-1.37,4.54a22.82,22.82,0,0,1-.72,4.59c-1.14,4.84-2.17,6.46-2.71,11s.38,7.64-.27,7.9-2-.26-2.18-3.92,1.38-9.82,2.52-12.74S158.2,222.64,158,220.68Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M154.77,244a.48.48,0,0,0,.23.13,10.91,10.91,0,0,1,7.31,4.28.47.47,0,0,0,.64.05.45.45,0,0,0,.05-.64,11.84,11.84,0,0,0-7.81-4.59.46.46,0,0,0-.54.36A.46.46,0,0,0,154.77,244Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M155.35,240.2a.48.48,0,0,0,.23.13,12.22,12.22,0,0,1,7.69,4.67.46.46,0,0,0,.66.05.46.46,0,0,0,0-.66,13.16,13.16,0,0,0-8.19-5,.48.48,0,0,0-.57.35A.49.49,0,0,0,155.35,240.2Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M155.27,236a.44.44,0,0,0,.25.14,13.93,13.93,0,0,1,8.6,5.25.53.53,0,0,0,.73.06.52.52,0,0,0,.05-.73,14.88,14.88,0,0,0-9.15-5.58.51.51,0,0,0-.62.38A.52.52,0,0,0,155.27,236Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M155.87,232.41a.48.48,0,0,0,.25.14,13.57,13.57,0,0,1,8.42,5.13.5.5,0,1,0,.76-.66,14.52,14.52,0,0,0-9-5.45.5.5,0,0,0-.61.38A.51.51,0,0,0,155.87,232.41Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M157.19,228.92a.48.48,0,0,0,.25.14,13.54,13.54,0,0,1,8.41,5.13.51.51,0,0,0,.77-.66,14.56,14.56,0,0,0-9-5.46.51.51,0,0,0-.61.38A.5.5,0,0,0,157.19,228.92Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "166.12 216.86 175.62 224.62 180.99 228 174.86 239.59 157.58 231.32 166.12 216.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M146.76,165s34.58-5.73,49.37-5.63c15.1.09,16.5,11.43,12.72,18.37-7.23,13.29-32.38,41.49-32.38,41.49S168,215.35,165.42,208l5.74-13.16-18,5.78-9.22-6.19-.75-4.7Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M146.76,165s34.58-5.73,49.37-5.63c15.1.09,16.5,11.43,12.72,18.37-7.23,13.29-32.38,41.49-32.38,41.49S168,215.35,165.42,208l5.74-13.16-18,5.78-9.22-6.19-.75-4.7Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M146.76,165,86.91,175s-.59,14.33,5,27.16a29.29,29.29,0,0,0,22.4,17.1,167.45,167.45,0,0,0,18.1,1.47,45.64,45.64,0,0,0,9.46,5.57c4.76,1.89,25.61,10.62,25.61,10.62s5.86-5,5.27-15.28l-19.68-20.94c-4.45-5.43-6-7.18-8.49-8.41C148.42,184.91,147.19,173.08,146.76,165Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M146.76,165,86.91,175s-.59,14.33,5,27.16a29.29,29.29,0,0,0,22.4,17.1,167.45,167.45,0,0,0,18.1,1.47,45.64,45.64,0,0,0,9.46,5.57c4.76,1.89,25.61,10.62,25.61,10.62s5.86-5,5.27-15.28l-19.68-20.94c-4.45-5.43-6-7.18-8.49-8.41C148.42,184.91,147.19,173.08,146.76,165Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M174.17,183.68a131.55,131.55,0,0,0-7.62,12.67l4.61-1.47c5.2-12.38,6.27-16,14.57-21.79C185.73,173.09,179.77,175.33,174.17,183.68Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M128,213.75s-.07,3,4.41,6.94a45.64,45.64,0,0,0,9.46,5.57c4.76,1.89,25.61,10.62,25.61,10.62s1.13-.52,2.75-3.59c-5.39-1.27-23.14-8.22-28.87-10.65C131.19,218.32,128,213.75,128,213.75Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M150.13,197.15l3,3.51,2.89-.95s-5.12-5.57-8.43-8.5a11.34,11.34,0,0,0-1.89-1.49c1.67-4.37,1.61-11.56,1.61-11.56a23.28,23.28,0,0,1-4.37,10.51,19.22,19.22,0,0,0-8.31-.1c-5.79,1-22.57,3.83-22.57,3.83s16.09-1.45,24.45-1.77S148.12,194.79,150.13,197.15Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M202.77,234c4.07,1.6,6.58,3.21,8.46,5.67s2.45,4.94.67,7.92-5.07,6.46-9,6.23-6.29-1.19-9.91-3.15Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M170.27,237.48c-.05,1.22,5.08,3.65,10.42,6.19,5.72,2.73,7.13,4.51,11.8,6.8,5.33,2.63,7.36,2.78,11.5,1.63s9.25-7.08,5.69-12.53c-2.9-4.44-6.66-5.66-12.36-7.16A108.64,108.64,0,0,1,184,228.1c-4.12-1.6-7.51-4.47-8.36-3.48.59.29,4.9,2.95,4.08,3.67-.2.37-.81.26-1.87-.18a1.78,1.78,0,0,0-1.48-.07,2.9,2.9,0,0,0-1.07,1.28,32.2,32.2,0,0,0-1.29,3.27c-.32.75-.18.31-.48,1.07a8.17,8.17,0,0,0-.88,2.92c.05.47.39.62.75.85s.87.51,1.21.77c.14.11.39.46.31.63s-.87.16-1.18,0-.83-.25-1.21-.39S171.22,237.92,170.27,237.48Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M190.65,249.59c.77.39,5.61,2.64,7.13,1.29s-2.23-3.79-2.23-3.79-.6-3.66,3.81-9c.77.59,3.95.56,3.91-1.31s-5.38-4.17-5.46-4.21c5.46,1.46,9.05,2.72,11.87,7C213.24,245,208.13,251,204,252.1s-6.17,1-11.5-1.63C192,250.21,191.12,249.87,190.65,249.59Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M196.07,246.72c2,.68.63,2.51-2.33,1.92-4.43-.9-8.12-3.41-13.05-5-5.34-2.54-10.77-4.92-10.42-6.26.95.35,3,1.21,3,1.21.4.17,1.43.55,1.43.55,4,1.75,8.51,4.55,12.89,5.74C191.44,246,194.05,246.05,196.07,246.72Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M199.07,238.75c-1.85-1.07-2.17-2-5.8-3.65s-9.75-5.23-13.54-7.43a48.58,48.58,0,0,1-4.11-3c.63-.71,2.94-.05,5.25,1.41s3.72,2.38,6,3.57c4.45,2.68,9.52,4.48,12.06,6.12S200.92,239.82,199.07,238.75Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M199.34,238.26a.54.54,0,0,1-.1.16,16.19,16.19,0,0,0-3.46,9,.54.54,0,0,1-.51.5.44.44,0,0,1-.41-.51,17,17,0,0,1,3.76-9.63.42.42,0,0,1,.65,0A.52.52,0,0,1,199.34,238.26Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M195.76,235.64a.56.56,0,0,1-.1.15,22.09,22.09,0,0,0-4.28,10.57.54.54,0,0,1-.52.48.44.44,0,0,1-.39-.53A22.68,22.68,0,0,1,195,235.12a.44.44,0,0,1,.65-.05A.54.54,0,0,1,195.76,235.64Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M187.86,246a.51.51,0,0,1-.43.32.44.44,0,0,1-.45-.48c.22-6.48,4.39-12.56,4.59-12.77a.43.43,0,0,1,.65,0,.57.57,0,0,1,0,.72c-.05.05-4.08,6-4.27,12A.8.8,0,0,1,187.86,246Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M184.54,243.86a.5.5,0,0,1-.42.32.43.43,0,0,1-.45-.47,19.05,19.05,0,0,1,4.83-12.11.43.43,0,0,1,.65,0,.58.58,0,0,1-.08.72,18.28,18.28,0,0,0-4.48,11.3A.54.54,0,0,1,184.54,243.86Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M180.24,242a.48.48,0,0,1-.41.32.43.43,0,0,1-.46-.46c0-6.74,4.77-12,5-12.16a.42.42,0,0,1,.65,0,.54.54,0,0,1-.07.71c-.05,0-4.61,5.1-4.64,11.35A.43.43,0,0,1,180.24,242Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M147.52,114c2.85,4.26,13.71,19.09,13.71,19.09s7-5,11.85-9.09,7.9-6,10.13-14A24.7,24.7,0,0,1,186,104.5a17.37,17.37,0,0,0,2.12-5.92c.11-1,2.74-.73,3.22,2.58.33,1.7-.23,3.39-.23,5.08,0,.52-.28,1.61.36,1.52,3.92-.56,6.8-5,11.49-8.17,1.69-1.13,6-2.3,6.94.15.08.6-.35,1-.51,1.54a.41.41,0,0,0,0,.22,3,3,0,0,0,.07.73c.11.5.32,1,.42,1.46a3.64,3.64,0,0,1-.26,2.23,8.92,8.92,0,0,0-.78,1.58,5.6,5.6,0,0,1-.41,3.07A12.14,12.14,0,0,1,207,113a9.38,9.38,0,0,0-.79,1.66,9.55,9.55,0,0,1-1.9,2.53,39.3,39.3,0,0,1-8.53,7.13c-1.45.85-3,1.55-4.35,2.53a12.86,12.86,0,0,0-2.7,2.56,79.65,79.65,0,0,0-5.26,6.29A174.5,174.5,0,0,1,169,153.79c-6,6.57-9.47,4-17.9-4.15-10.35-10-15.9-15.72-15.9-15.72l-2.51-33.1C138.83,102.87,144.66,109.75,147.52,114Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M191,110.57a11.21,11.21,0,0,1-2.89,9.62C191.71,119.21,193.16,114.6,191,110.57Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M129.54,99.79c5.75,1,10.23,3.25,17.46,12.82s14.23,20,14.23,20l6.85-4.6c-1.85,1.07-.31,8.4,2.66,12.09a14.1,14.1,0,0,0,6.69,4.64,50.26,50.26,0,0,1-6.76,8.47c-3.67,3.42-5.34,4.66-7.87,4.66s-5.32-1.46-11.93-7.75-17.13-16.33-17.13-16.33Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M161.23,132.61c-3.07,3.39-5.24,9.33-5,12.39-1.29-3.58,0-9.67,3.9-14.07Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M174.24,149.09a11.82,11.82,0,0,1-2.12-.65,12.28,12.28,0,0,1-3.77-2.46,13.12,13.12,0,0,1-3.84-7.52c0-.14-.17-.1-.16,0a12,12,0,0,0,3.8,8.2,12.9,12.9,0,0,0,4,2.49,11.81,11.81,0,0,0,1.72.54l.49-.61Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M139.27,120.68c-.81-16.08-4.44-20.51-12.59-21.41l-13.46-1.42c-4,.82-17.73,5.19-22.35,6.8-3,1-4.26,7.36-4.9,17.27-.52,8-.6,14.8-.34,25.93.23,9.32.46,20,3.3,32.91,11.14,4.22,43.31.19,56.14-14.51-1-3.32-5.15-9.33-5.8-16C139.69,136.25,139.52,125.73,139.27,120.68Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M90.57,104.44l10-3.53s1.82,4.22,5.71,12.32,4,11.78,4.4,25.92,3,39,4.63,44.73c-6.23.87-11.63,9.9-27.63,7.1,0,0-3.36-16.38-3.88-44.27C83.57,132.25,83.49,108.53,90.57,104.44Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M110.16,126.48c-1.57-12.7-6.89-13.36-8.12-9.18-4.62-6.92-5.48-12.62-5.41-15,1.26-1.84,2.33-3.48,2.83-4.26a3.39,3.39,0,0,1,2.05-1.65l.08,3.49s.34,3.4,4.13,8.07C108.51,111.38,109.49,115.77,110.16,126.48Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M119.31,99.71c5.72,2.23,9.92,8.58,11.27,17.37s2.46,31.23,3.4,37.86,5.19,18.19,5.19,18.19,7-2.89,9-8.4c-3.23-4.21-6.23-10.07-6.79-15.6s0-23.15-.88-29.9-1.54-16.06-9.54-19.17c-3.44-1.34-11.55-1.87-11.55-1.87Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M131.19,122.16c-.78-6.47-4.46-18-11.46-20.4a5.56,5.56,0,0,1-.42-2.05l.07-3.36a28.53,28.53,0,0,1,6,2.92c3,2,8.24,8.19,9.59,13.23C131.9,109.93,130.7,114.11,131.19,122.16Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M102,94.18c-1.09-4.42-5.88-8.76-8.18-12.51s-3.57-6.45-3.61-10c0-2.11,1.08-5,2.59-5.75a23.1,23.1,0,0,1-.51-4.09,12.39,12.39,0,0,1,.94-3.74,13.5,13.5,0,0,1,4.86-6c3.07-2.08,6.86-2.8,10.56-3s7.42,0,11.1-.5,7.4-1.68,10-4.29a9.16,9.16,0,0,0,.22,2c.05.79.07,1.59.06,2.38a10.57,10.57,0,0,1-.25,3.68,9.27,9.27,0,0,0,3.64-3.68c.44,3.42.82,7.14-1,10.1A2.91,2.91,0,0,1,134,60.9a8.93,8.93,0,0,1-.53,5.58,13.37,13.37,0,0,1-3.34,4.58,23.28,23.28,0,0,1-8.64,4.74,61.3,61.3,0,0,1-9.71,2,1.15,1.15,0,0,0-.57.2,1.13,1.13,0,0,0-.23.4c-1.26,3.07-3.31,6-5,8.84l-3.94,6.82A.39.39,0,0,0,102,94.18Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M96,87.26a4.34,4.34,0,0,0,5.27-.39l.36,14.93c2.73,6.22,13.22,8.76,18.76,8.36a18.15,18.15,0,0,0-.45-9.73l-.1-4.05a14.92,14.92,0,0,0,5.48-.93A10.23,10.23,0,0,0,132,87.63c.88-4,.71-8.82.05-13.79-.16-1.23-.3-2.76-.35-4a21.05,21.05,0,0,0-1.45-6.45,17.18,17.18,0,0,0-3.18-5.27,1.1,1.1,0,0,0-.61-.45,1.08,1.08,0,0,0-.63.12c-1,.5-1.7,1.55-2.57,2.32-1.82,1.61-4.45,1.91-6.87,1.74a22.39,22.39,0,0,1-7.06-1.71,1.21,1.21,0,0,0-.88-.14.79.79,0,0,0-.45.69,2.21,2.21,0,0,0,.13.84c.8,2.74,1.47,6,.41,8.78a8.37,8.37,0,0,1-1.63,2.57c-.18.2-2.14,1.71-2.13,1.73.22,1.33.54,4.71-1.67,4.74-1.59,0-1.78-2-3.48-3.64s-5.53-2-6.89.66C90.84,80.08,92.45,85.35,96,87.26Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M119.83,96.38c-5.6-.41-9-1.24-12.94-4.34-3.06-2.44-4.33-7.88-4.33-7.88s0,6.17,2.9,9.59c1.91,2.23,5.65,4.82,14.42,5.19Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M116.66,74a1.57,1.57,0,1,1-1.61-1.59A1.59,1.59,0,0,1,116.66,74Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M115.1,69.15l-3.26,2a2,2,0,0,1,.64-2.71A1.87,1.87,0,0,1,115.1,69.15Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M130,69.94l-3.68-1.19a1.86,1.86,0,0,1,2.37-1.28A2,2,0,0,1,130,69.94Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M129.41,73a1.57,1.57,0,1,1-1.47-1.73A1.6,1.6,0,0,1,129.41,73Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M120.77,72.05c.5.69,1,1.36,1.52,2s1,1.31,1.59,2a45.63,45.63,0,0,0,3.48,3.61l.47.44-.62.11c-.81.14-1.64.24-2.46.35s-1.65.2-2.48.26c.8-.24,1.6-.47,2.4-.66s1.61-.4,2.42-.57l-.15.55a23,23,0,0,1-3.55-3.69,23.2,23.2,0,0,1-1.45-2.11A19.47,19.47,0,0,1,120.77,72.05Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M116,83.92,122.61,85a3.3,3.3,0,0,1-3.8,2.86A3.52,3.52,0,0,1,116,83.92Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M116.83,85a3.6,3.6,0,0,0-.81,0,3.46,3.46,0,0,0,2.79,2.9,3.25,3.25,0,0,0,1.08,0A3.09,3.09,0,0,0,116.83,85Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arm-2",
    "data-name": "Arm"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laptop"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M184.59,193.83a9.9,9.9,0,0,0-1.61-1.89c-6.19-5.73-17.8-13.29-27.68-19.58l-44.91,25.93a.42.42,0,0,0,0,.72L143,217.84Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M198.21,180.65v.72a3,3,0,0,1-1.49,2.59L144.5,214.1a3,3,0,0,1-1.49.4,3,3,0,0,1-1.5-.4l-28.46-16.38a3,3,0,0,1-1.49-2.58v-1h0a.38.38,0,0,0,.19.33L143,212.52Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M143,212.51v2a3,3,0,0,0,1.49-.4L196.72,184a3,3,0,0,0,1.49-2.59v-.73Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M198.21,180.64l-31-17.87a1.77,1.77,0,0,0-1.78,0l-53.71,31a.39.39,0,0,0,0,.68L143,212.52Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "142.73 209.89 126.03 200.26 174.86 172.06 191.64 181.65 142.73 209.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "191.64 181.65 191 182.01 174.85 172.8 126.67 200.62 126.03 200.26 174.85 172.06 191.64 181.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "134.52 183.09 134.83 183.27 143.01 188 157.57 179.59 157.87 179.42 149.38 174.52 134.52 183.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "134.83 183.27 143.01 188 157.57 179.59 149.38 174.87 134.83 183.27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arm-3",
    "data-name": "Arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M151,186.65c-2.62-2.6-6.42-6.2-9.62-7.26a16.83,16.83,0,0,0-2.24-.69,26.09,26.09,0,0,0,3.28-.66,5.78,5.78,0,0,0,2.77-1.84c.28-.35.48-.92.13-1.21a.83.83,0,0,0-.46-.17c-2.39-.07-4.28-.44-6.45-.6a9.28,9.28,0,0,0-2.93.05c-.89.25-1.78.51-2.65.81-4,1.37-7.73,1-13.21-1.51s-25.22-14.66-25.22-14.66l4.18,23.16,15.62,6h0l.17.06a37.54,37.54,0,0,0,5.36,2.36c3.54,1.09,8.06-.2,11.14-.36s8.28,1.25,11.13,2.41,6.28-3.23,7.71-2.7S153.59,189.25,151,186.65Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M137.79,177a10.77,10.77,0,0,0-4.36.71,23.47,23.47,0,0,1,5.68,1,26.09,26.09,0,0,0,3.28-.66,6.08,6.08,0,0,0,2.52-1.54C143.19,177.67,139.86,177.21,137.79,177Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M143.85,213a3.56,3.56,0,0,0,3.05-.24l52-30a3.54,3.54,0,0,0,1.72-2.47l5.69-33.94a3.69,3.69,0,0,0,0-.58,3.52,3.52,0,0,0-1-2.51l-54,31.19a2.67,2.67,0,0,0-1.27,1.83Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M143,212.52l.36.2a4.3,4.3,0,0,0,.48.24L150,176.22a2.67,2.67,0,0,1,1.27-1.83l54-31.19a3.92,3.92,0,0,0-.72-.55L150.44,173.9a2.65,2.65,0,0,0-1.27,1.83Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M150.51,175.09l-.84-.49a2.62,2.62,0,0,0-.5,1.13L143,212.52l.36.2a4.3,4.3,0,0,0,.48.24L150,176.22A2.59,2.59,0,0,1,150.51,175.09Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M173.13,181.62c.38-2.27,2.73-5.29,5.24-6.74s4.24-.78,3.86,1.49-2.73,5.29-5.24,6.74S172.75,183.9,173.13,181.62Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M109.55,169.72c-8.33-6-15.18-10.81-15.18-10.81l2.38-25.59s1.8-12.66-1-19.82c-3-7.43-5.89-8.48-5.89-8.48a28.68,28.68,0,0,0-8,4.52c-3.23,2.82-4.76,9.38-5.54,18.62-.69,8.12-2,28.47-2.17,33.22-.26,6,0,10.88,6.4,13.79,6.73,3.08,26.92,10,26.92,10Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M90.57,104.44c-6.55,2.1-9.89,3.3-12.65,11s-2.67,21.75-3.52,33-1.47,18.66.34,22.22c1,2,2.81,3.75,9.29,6.2s12.72,4.66,12.72,4.66.62-10,7.73-16.68l-9.77-5.94s2.24-23,2.79-29.35S98.71,109.9,90.57,104.44Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M94.71,158.91c-3.83-1.81-11.42-.18-13,1.19,1.93-3.34,7.1-4.55,13.29-3.77Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M97.18,165.85a9.24,9.24,0,0,0-2.82,3.29,16.55,16.55,0,0,0-1.56,3.91,21.25,21.25,0,0,0-.66,4.76,20.31,20.31,0,0,0,0,2.06l.72.27a20,20,0,0,1,.57-6.85,17.71,17.71,0,0,1,1.5-3.83,38,38,0,0,1,2.3-3.43C97.29,166,97.28,165.79,97.18,165.85Z",
    transform: "translate(0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandpostioningtab);
export default __webpack_public_path__ + "static/media/brand postioning tab.2f56b70effa2e9ff18014a7acfea96be.svg";
export { ForwardRef as ReactComponent };